export default __webpack_public_path__ + "static/media/captur-medium1.eeb2a27c.jpg";